// extracted by mini-css-extract-plugin
export default {"image-card":"ImageCard_image-card__yPoJT","selected":"ImageCard_selected__t-mDs","tick-icon":"ImageCard_tick-icon__57HGF","caption":"ImageCard_caption__LTYxY"};